// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2mgwY","modalFooterButton":"ModalNotes_modalFooterButton__2LqbQ"};